export default {
  'myProperties': ['VENDOR'],
  'recentProfiles': ['USER'],
  'dashboardData': ['USER'],
  'leaseRadar': ['USER'],
  'ampReports': ['USER'],
  'subscriptionsTracker': ['USER']
}